module.exports = __webpack_public_path__ + "450436cbf7cbe4f3df8f914ec62464fa.ttf";